export default __webpack_public_path__ + "static/media/icon_pin_red.20616a36.svg";